import { CalAngularService } from '@cvx/cal-angular';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommondialogComponent } from '../component/commondialog/commondialog.component';
//import { CommondialogComponent } from '../component/commondialog/commondialog.component';
import { RoleService } from './RoleService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})export class SharedServices {
  loggedUserCai: string = '';
  loggedUserEmail:string='';

  constructor(private authService: CalAngularService,private dialog: MatDialog,) {}

  getloggedUserCai() {
    if (this.authService.isUserSignedIn()) {
      this.loggedUserCai = this.authService.cvxClaimsPrincipal.logOnName ?? '';
      this.loggedUserEmail=this.authService.cvxClaimsPrincipal.userName ?? '';
    }
    return this.loggedUserCai;
  }
  getloggedUserEmail() {
    if (this.authService.isUserSignedIn()) {
      this.loggedUserEmail=this.authService.cvxClaimsPrincipal.userName ?? '';
    }
    return this.loggedUserEmail;
  }
  openModal(messageTitle: string, messageDesc: string): void {
    this.dialog.open(CommondialogComponent, {
      data: { title: messageTitle, modalMessage: messageDesc },
      width: 'auto',
      position: { top: '1'},
    });
  }

  closeModal(): void {
    this.dialog.closeAll();
  }
  hasRoleA(roleService: RoleService): Observable<boolean> {
    return roleService.hasRole(['A']);
  }
}


